export const TypeHistoryEnum= Object.freeze({
    search: "search",
    place: "place"
})